import { render, staticRenderFns } from "./DeleteCurrency.vue?vue&type=template&id=edcbebb4"
import script from "./DeleteCurrency.vue?vue&type=script&lang=js"
export * from "./DeleteCurrency.vue?vue&type=script&lang=js"
import style0 from "./DeleteCurrency.vue?vue&type=style&index=0&id=edcbebb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports